import { readFile } from "node:fs/promises";
import type { WakeLoopPathResolutionInput } from "../../config/paths";
import {
  daemonServiceExecutableWrapperPath,
  daemonServiceLauncherPath,
  daemonServiceLegacyWrapperPath,
} from "./daemon-service-bundle";
import type { DaemonServiceManager } from "./daemon-service-manager";

export function matchesExpectedDaemonServiceManagerCommand(input: {
  controller: DaemonServiceManager["controller"] | null;
  commandSummary: string;
  definitionPath: string | null;
  includeLegacyExecutableWrappers?: boolean;
  pathInput?: WakeLoopPathResolutionInput;
}): boolean {
  if (input.controller === "windows-service") {
    return (
      typeof input.definitionPath === "string" &&
      input.definitionPath.length > 0 &&
      input.commandSummary.includes(input.definitionPath)
    );
  }
  return resolveExpectedDaemonServiceManagerCommandPaths({
    controller: input.controller,
    includeLegacyExecutableWrappers:
      input.includeLegacyExecutableWrappers === true,
    pathInput: input.pathInput,
  }).some((path) => input.commandSummary.includes(path));
}

export async function matchesExpectedDaemonServiceManagerDefinition(input: {
  controller?: DaemonServiceManager["controller"] | null;
  definitionPath: string | null;
  pathInput?: WakeLoopPathResolutionInput;
}): Promise<boolean> {
  if (
    typeof input.definitionPath !== "string" ||
    input.definitionPath.trim().length === 0
  ) {
    return false;
  }

  const definition = await readFile(input.definitionPath, "utf8").catch(
    () => null
  );
  if (definition === null) {
    return false;
  }

  return resolveExpectedDaemonServiceManagerCommandPaths({
    controller: input.controller ?? null,
    pathInput: input.pathInput,
  }).some((path) => definition.includes(path));
}

function resolveExpectedDaemonServiceManagerCommandPaths(input: {
  controller: DaemonServiceManager["controller"] | null;
  includeLegacyExecutableWrappers?: boolean;
  pathInput?: WakeLoopPathResolutionInput;
}): string[] {
  if (input.controller === "launchd") {
    return [
      daemonServiceExecutableWrapperPath(input.pathInput),
      ...(input.includeLegacyExecutableWrappers === true
        ? [daemonServiceLegacyWrapperPath(input.pathInput)]
        : []),
    ];
  }
  return [daemonServiceLauncherPath(input.pathInput)];
}
